import { TextInput } from "ra-ui-materialui";

const DefaultForm = () => (
  <>
    <TextInput
      source="title"
      fullWidth
    />
    <TextInput
      source="title_en"
      fullWidth
    />
    <TextInput
      source="route"
      fullWidth
    />
  </>
);

export default DefaultForm;
